import './Trending.scss';
const Trending = () => {
  return (
    <div className="_trending">
      <div className="container">
        <div className="wrapper">
          <h3 className="title-section text-center mb-4">Tier Mechanism</h3>
          <div className="row justify-content-center">
            <div className="col-md-3 mb-4">
              <div className="card border-0 cardShadow">
                <div className="card-body p-0 text-center">
                  <img src="/images/royalist-1.jpg" className="img-fluid w-100" alt="royalist1" />
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-0 cardShadow">
                <div className="card-body p-0 text-center">
                  <img src="/images/royalist-2.jpg" className="img-fluid w-100" alt="royalist1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Trending
